import script from "./StatCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatCard.vue?vue&type=script&setup=true&lang=ts"

import "./StatCard.vue?vue&type=style&index=0&id=5b299dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b299dcc"]])

export default __exports__